import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

export const translations = {
  'en-US': {
    // Common terms
    'common.today': 'Today',
    'common.learn-more': 'Learn more',
    'common.take-look': 'Take a look',
    'common.lunch-list': 'Lunch list',
    'common.floor': 'Floor',
    'common.closed': 'Closed',
    'common.search': 'Search',
    'common.stores': 'Stores',
    'common.grocery': 'Groceries',
    'common.offers': 'Offers',
    'common.events': 'Events',
    'common.news': 'News',
    'common.store': 'Store',
    'common.store-name': 'Store',
    'common.category': 'Category',
    'common.see-all': 'See all',
    'common.see-more': 'See more',
    'common.see-less': 'See less',
    'common.read-more': 'Read more',
    'common.read-less': 'Read less',
    'common.load-more': 'Load more',
    'common.more-info': 'More information',
    'common.clear-selection': 'Clear selection',
    'common.clear.search': 'Clear search',
    'common.opening-hours': 'Opening hours',
    'common.valid': 'Valid',
    'common.no-results': 'No results found',
    'common.no-content': 'No content currently available',
    'common.follow-instagram': 'Follow us on instagram',
    'common.no-opening-hours': 'No opening hours currently available',
    'common.no-content-available': 'No content currently available',
    'common.lunchMenu': 'Lunch menu',
    'common.visit': 'Visit',
    
    // Weekdays should be common
    'common.weekdays.monday': 'Monday',
    'common.weekdays.tuesday': 'Tuesday',
    'common.weekdays.wednesday': 'Wednesday',
    'common.weekdays.thursday': 'Thursday',
    'common.weekdays.friday': 'Friday',
    'common.weekdays.saturday': 'Saturday',
    'common.weekdays.sunday': 'Sunday',
    'common.weekdays': 'Weekdays',
    'common.exceptional-hours': 'Exceptional opening hours',
    'common.mon-fri': 'Mon-Fri',
    'common.mon': 'Mon',
    'common.tue': 'Tue',
    'common.wed': 'Wed',
    'common.thu': 'Thu',
    'common.fri': 'Fri',
    'common.sat': 'Sat',
    'common.sun': 'Sun',
    'common.open-during-weekdays': 'Open during weekdays',
    'common.open': 'Open',
    'common.open-on': 'Open on',
    'common.openToday': 'Open today',

    'opening-hours-swiper.todays-hours': "Today's hours",
    'opening-hours-swiper.tomorrows-hours': "Tomorrow's hours",
    'opening-hours-swiper.day-after-hours': "Day after tomorrow's hours",
    'opening-hours-swiper.store-hours-vary': 'See individual stores opening hours',
    
    'footer.connect': 'connect',
    'footer.all-hours': 'see all hours',
    'footer.visit-us': 'visit us',
    'footer.privacy-center': 'Privacy center',
    
    'search.no-results': 'Your search did not match any results',
    'search.results': 'Search results',
    'search.opening-hours-not-available': 'Opening hours not available',
    'search.view-store': 'View store',
    'search.call-store': 'Call us',
    'search.floor-1': '1st floor',
    'search.floor-2': '2nd floor',
    'search.floor-3': '3rd floor',
    'search.floor-4': '4th floor',
    'search.floor-5': '5th floor',
    'search.store-section-header': 'Stores',
    'search.offer-section-header': 'Offers',
    'search.event-section-header': 'Events',
    'search.results-for': 'Results for',
    'search.no-results-suggestion': 'Try different keywords or check your spelling',
    'search.searching': 'Searching...',

    'stores.all-categories': 'All categories',
    'stores.no-results': 'No stores found',
    'stores.all': 'All',
    'stores.search-placeholder': 'Search stores...',
    'stores.all-floors': 'All floors',
    'stores.floor-1': '1st floor',
    'stores.floor-2': '2nd floor',
    'stores.floor-3': '3rd floor',
    'stores.floor-4': '4th floor',
    'stores.floor-5': '5th floor',
    'stores.select-category': 'Select category',
    'stores.opening-hours': 'Opening hours',
    'stores.phone': 'Phone',
    'stores.email': 'Email',
    'stores.website': 'Website',
    'stores.address': 'Address',
    'stores.location': 'Location',
    'stores.floor': 'Floor',
    'stores.category': 'Category',
    'stores.today': 'Today',
    'stores.tomorrow': 'Tomorrow',

    'store.see-on-map': 'See on the map',
    'store.exceptions': 'Exceptions',
    'store.all-offers': 'See all',
    'store.related': 'Related stores',
    'store.all-related': 'See all related stores',
    'store.status.CLOSED': 'Closed',
    'store.status.TEMPORARY_CLOSED': 'Temporary closed',
    'store.status.OPEN': 'Open',
    'store.status.BY_APPOINTMENT': 'By appointment',

    'store-listing-item-gift-card-support.label': 'We accept gift cards',

    'offers.all-categories': 'All categories',
    'offers.lowest-price-30-days': '30 days lowest price',
    'offers.search-placeholder': 'Search offers, descriptions, stores...',
    'offers.no-results': 'No offers found',

    'lunch-list.modal-title': 'Lunch list',
    'about-us.opening-hours-note': 'For specific hours of operation at your favorite shopping and dining destinations:',
    'about-us.opening-hours-goto-stores': 'Go to stores',
    'about-us.opening-hours-center-doors-open': 'Center doors open',
    'about-us.parking-title': 'Parking',
    'about-us.sustainability-title': 'Sustainability',
    'about-us.contact-us-title': 'Contact us',
    'about-us.opening-hours-exceptional': 'Exceptional opening hours',
    'about-us.navigation-tabs-placeholder': 'Select topic',

    // For campaign pages:
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.send-email': 'Send email',
    'offers.loading': 'Loading...',
    'offers.valid': 'Valid',
    'offers.noSearchResults': 'No results found for your search',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'offers.selectedDays': '{count} days selected',
    'offers.selectedCategories': '{count} categories selected',
    'search.noResults': 'No results',
    'search.placeholder': 'Search',
    'campaign.all-program': 'Show all programs',
    'campaign.all-days': 'All days',
    'campaign.all-categories': 'All categories',

    'news-and-events.news-and-events': 'News and events ',
    
    'offer-lists.search-filter-store-name': 'Store',
    'offer-lists.valid-from': 'Valid from',

    'news-and-events-lists.search-filter-keyword': 'Keyword',

    'news-and-events-single-article.read.more': 'Read more news & events',

    'news-letter-lift.email-address': 'Enter your email address here',
    'news-letter-lift.subscribe': 'Subscribe',
    'news-letter-lift.confirmation-message': 'You have successfully subscribed to the newsletter!',

    'feedback.required_fields_marked_by_star': 'Required fields',
    'feedback.target': 'Target',
    'feedback.choose_shop' : 'Choose a shop',
    'feedback.type_of_feedback' : 'Type of feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Name',
    'feedback.email' : 'Email',
    'feedback.target.general': 'General feedback',
    'feedback.target.store': 'Feedback to a specific company',
    'feedback.type.thanks': 'Thanks',
    'feedback.type.suggestion': 'Suggestion',
    'feedback.type.complaint': 'Complaint',
    'feedback.type.other': 'Other',
    'feedback.rsvp' : 'I would like to receive a reply',
    'feedback.privacy_statement' : 'Privacy policy',
    'feedback.thank_you' : 'Thank you for your feedback',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
    'feedback.error.field_required' : 'Field is required',
    'feedback.error.invalid_email_address' : 'Invalid email address',
    'feedback.error.please_choose_a_store' : 'Please choose a store',
  },
  'fi-FI': {
    // Common terms
    'common.today': 'Tänään',
    'common.learn-more': 'Lue lisää',
    'common.take-look': 'Tutustu tarkemmin',
    'common.lunch-list': 'Lounaslista',
    'common.floor': 'Krs',
    'common.closed': 'Suljettu',
    'common.search': 'Haku',
    'common.stores': 'Liikkeet',
    'common.grocery': 'Ruokaostokset',
    'common.offers': 'Tarjoukset',
    'common.events': 'Tapahtumat',
    'common.news': 'Uutiset',
    'common.store': 'Liike',
    'common.store-name': 'Liikkeet',
    'common.category': 'Kategoria',
    'common.see-all': 'Katso kaikki',
    'common.see-more': 'Näytä lisää',
    'common.see-less': 'Näytä vähemmän',
    'common.read-more': 'Lue lisää',
    'common.read-less': 'Lue vähemmän',
    'common.load-more': 'Näytä lisää',
    'common.more-info': 'Lisätietoja',
    'common.clear-selection': 'Tyhjennä valinta',
    'common.clear.search': 'Tyhjennä haku',
    'common.opening-hours': 'Aukioloajat',
    'common.valid': 'Voimassa',
    'common.no-results': 'Tuloksia ei löytynyt',
    'common.no-content': 'Ei näytettävää sisältöä juuri nyt',
    'common.follow-instagram': 'Seuraa meitä instagramissa',
    'common.no-opening-hours': 'Ei aukioloaikoja tällä hetkellä saatavilla',
    'common.no-content-available': 'Ei näytettävää sisältöä juuri nyt',
    'common.lunchMenu': 'Lounaslista',
    'common.visit': 'Tutustu',

    // Weekdays should be common
    'common.weekdays.monday': 'maanantai',
    'common.weekdays.tuesday': 'tiistai',
    'common.weekdays.wednesday': 'keskiviikko',
    'common.weekdays.thursday': 'torstai',
    'common.weekdays.friday': 'perjantai',
    'common.weekdays.saturday': 'lauantai',
    'common.weekdays.sunday': 'sunnuntai',
    'common.weekdays': 'arkipäivät',
    'common.exceptional-hours': 'Poikkeavat aukioloajat',
    'common.mon-fri': 'ma-pe',
    'common.mon': 'ma',
    'common.tue': 'ti',
    'common.wed': 'ke',
    'common.thu': 'to',
    'common.fri': 'pe',
    'common.sat': 'la',
    'common.sun': 'su',
    'common.open-during-weekdays': 'Auki veckodagarna',
    'common.open': 'Auki',
    'common.open-on': 'Auki päivänä',
    'common.openToday': 'Avoinna tänään',
    'opening-hours-swiper.todays-hours': 'Aukioloajat tänään',
    'opening-hours-swiper.tomorrows-hours': 'Aukioloajat huomenna',
    'opening-hours-swiper.day-after-hours': 'Aukioloajat ylihuomenna',
    'opening-hours-swiper.store-hours-vary': 'Katso yksittäisten liikkeiden aukioloajat',
    
    'footer.connect': 'Sosiaalinen media',
    'footer.all-hours': 'Katso aukioloajat',
    'footer.visit-us': 'Vieraile meillä',
    'footer.privacy-center': 'Tietosuojakäytäntö',
    
    'search.no-results': 'Hakusi ei tuottanut yhtään tulosta',
    'search.results': 'Hakutulokset',
    'search.opening-hours-not-available': 'Aukioloaikoja ei ole saatavilla',
    'search.view-store': 'Katso liikkeet',
    'search.call-store': 'Soita meille',
    'search.floor-1': '1. krs',
    'search.floor-2': '2. krs',
    'search.floor-3': '3. krs',
    'search.floor-4': '4. krs',
    'search.floor-5': '5. krs',
    'search.store-section-header': 'Liikkeet',
    'search.offer-section-header': 'Tarjoukset',
    'search.event-section-header': 'Tapahtumat',
    'search.results-for': 'Tulokset hakusanalle',
    'search.no-results-suggestion': 'Yritä eri hakusanoja tai tarkista kirjoitusvirheet',
    'search.searching': 'Hakutulokset ladataan...',
    
    'stores.all-categories': 'Kaikki kategoriat',
    'stores.no-results': 'Valitettavasti yhtään liikettä ei löytynyt',
    'stores.all': 'Kaikki',
    'stores.search-placeholder': 'Hae liikkeitä...',
    'stores.all-floors': 'Kaikki kerrokset',
    'stores.floor-1': '1. kerros',
    'stores.floor-2': '2. kerros',
    'stores.floor-3': '3. kerros',
    'stores.floor-4': '4. kerros',
    'stores.floor-5': '5. kerros',
    'stores.select-category': 'Valitse kategoria',
    'stores.opening-hours': 'Aukioloajat',
    'stores.phone': 'Puhelin',
    'stores.email': 'Sähköposti',
    'stores.website': 'Verkkosivu',
    'stores.address': 'Osoite',
    'stores.location': 'Sijainti',
    'stores.floor': 'Kerros',
    'stores.category': 'Kategoria',
    'stores.today': 'Tänään',
    'stores.tomorrow': 'Huomenna',
    'store.see-on-map': 'Katso pohjakartalla',
    'store.exceptions': 'Poikkeavat aukioloajat',
    'store.all-offers': 'Kaikki tarjoukset',
    'store.related': 'Samanlaiset liikkeet',
    'store.all-related': 'Näytä kaikki liittyvät kaupat',
    'store.status.CLOSED': 'Suljettu',
    'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
    'store.status.OPEN': 'Auki',
    'store.status.BY_APPOINTMENT': 'Tilauksella',
    'store-listing-item-gift-card-support.label': 'Hyväksymme lahjakortit',

    'offers.all-categories': 'Kaikki kategoriat',
    'offers.lowest-price-30-days': '30 pv alin hinta',
    'offers.search-placeholder': 'Hae tarjouksia, kuvausten ja liikkeiden perusteella',
    'offers.no-results': 'Tarjouksia ei löytynyt',

    'about-us.opening-hours-note': 'Tietyt aukioloajat suosikkiostos- ja ruokailukohteissasi:',
    'about-us.opening-hours-goto-stores': 'Katso liikkeet ja palvelut',
    'about-us.opening-hours-center-doors-open': 'Kauppakeskuksen ovet auki',
    'about-us.parking-title': 'Pysäköinti',
    'about-us.sustainability-title': 'Kestävä kehitys',
    'about-us.contact-us-title': 'Ota yhteyttä',
    'about-us.opening-hours-exceptional': 'Poikkeavat aukioloajat',
    'about-us.navigation-tabs-placeholder': 'Valitse aihe',

    // For campaign pages:
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.send-email': 'Lähetä sähköposti',
    'offers.loading': 'Ladataan...',
    'news-and-events.news-and-events': 'Uutiset ja tapahtumat',
    'lunch-list.modal-title': 'Lunch List',
    'offers.valid': 'Voimassa',
    'offer-lists.search-filter-store-name': 'Liikkeet',
    'offer-lists.valid-from': 'Voimassa',
    'offers.noSearchResults': 'Hakutuloksia ei löytynyt',
    'offers.noContent':'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox':'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'offers.selectedDays': '{count} päivää valittu',
    'offers.selectedCategories': '{count} toimialaa valittu',
    'search.noResults': 'Ei tuloksia',
    'search.placeholder': 'Hae',
    'campaign.all-program': 'Koko ohjelma',
    'campaign.all-days': 'Kaikki päivät',
    'campaign.all-categories': 'Kaikki toimialat',

    'news-and-events-lists.search-filter-keyword': 'Avainsana',

    'news-and-events-single-article.read.more': 'Lue lisää uutisia ja tapahtumia',

    'news-letter-lift.email-address': 'Kirjoita sähköpostiosoitteesi tähän',
    'news-letter-lift.subscribe': 'Tilaa uutiskirje',
    'news-letter-lift.confirmation-message': 'Olet onnistuneesti tilannut uutiskirjeen!',

    'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
    'feedback.target': 'Kohde',
    'feedback.choose_shop' : 'Valitse liike',
    'feedback.type_of_feedback' : 'Palautteen tyyppi',
    'feedback.message': 'Palaute',
    'feedback.name' : 'Nimesi',
    'feedback.email' : 'Sähköpostiosoitteesi',
    'feedback.target.general': 'Haluan antaa yleistä palautetta',
    'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
    'feedback.type.thanks': 'Kiitos',
    'feedback.type.suggestion': 'Ehdotus',
    'feedback.type.complaint': 'Moite',
    'feedback.type.other': 'Muu',
    'feedback.rsvp' : 'Haluan, että minulle vastataan',
    'feedback.privacy_statement' : 'Rekisteriseloste',
    'feedback.thank_you' : 'Kiitos palautteesta!',
    'feedback.send': 'Lähetä',
    'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
    'feedback.error.field_required' : 'Kenttä on pakollinen',
    'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
    'feedback.error.please_choose_a_store' : 'Valitse liike',
  },
  'sv-SE': {
    // Common terms
    'common.today': 'Idag',
    'common.learn-more': 'Läs mer',
    'common.take-look': 'Ta en närmare titt',
    'common.lunch-list': 'Lunchlista',
    'common.floor': 'Våning',
    'common.closed': 'Stängt',
    'common.search': 'Sök',
    'common.stores': 'Butiker',
    'common.grocery': 'Livs',
    'common.offers': 'Erbjudanden',
    'common.events': 'Evenemang',
    'common.news': 'Nyheter',
    'common.store': 'Butik',
    'common.store-name': 'Butiker',
    'common.category': 'Kategori',
    'common.see-all': 'Se alla',
    'common.see-more': 'Se mer',
    'common.see-less': 'Se mindre',
    'common.read-more': 'Läs mer',
    'common.read-less': 'Läs mindre',
    'common.load-more': 'Visa mer',
    'common.more-info': 'Mer information',
    'common.clear-selection': 'Rensa val',
    'common.clear.search': 'Rensa sökning',
    'common.opening-hours': 'Öppettider',
    'common.valid': 'Gäller',
    'common.no-results': 'Inga resultat hittades',
    'common.no-content': 'Inget innehåll tillgängligt för tillfället',
    'common.follow-instagram': 'Följ oss på instagram',
    'common.no-opening-hours': 'Inga öppettider tillgängliga för tillfället',
    'common.no-content-available': 'Inget innehåll tillgängligt för tillfället',
    'common.lunchMenu': 'Lunchmeny',
    'common.visit': 'Besök',
    
    // Weekdays should be common
    'common.weekdays.monday': 'måndag',
    'common.weekdays.tuesday': 'tisdag',
    'common.weekdays.wednesday': 'onsdag',
    'common.weekdays.thursday': 'torsdag',
    'common.weekdays.friday': 'fredag',
    'common.weekdays.saturday': 'lördag',
    'common.weekdays.sunday': 'söndag',
    'common.weekdays': 'vardagar', 
    'common.exceptional-hours': 'Särskilda öppettider',
    'common.mon-fri': 'mån-fre',
    'common.mon': 'Mån',
    'common.tue': 'Tis',
    'common.wed': 'Ons',
    'common.thu': 'Tors',
    'common.fri': 'Fre',
    'common.sat': 'Lör',
    'common.sun': 'Sön',
    'common.open-during-weekdays': 'Öppettider vardagar',
    'common.open': 'Öppet',
    'common.open-on': 'Öppet på',
    'common.openToday': 'Öppet idag',
    'opening-hours-swiper.todays-hours': 'Dagens öppettider',
    'opening-hours-swiper.tomorrows-hours': 'Morgondagens öppettider',
    'opening-hours-swiper.day-after-hours': 'Öppettider i övermorgon',
    'opening-hours-swiper.store-hours-vary': 'Se enskilda butikers öppettider',
    
    'footer.connect': 'Anslut',
    'footer.all-hours': 'Se alla öppettider',
    'footer.visit-us': 'Besök oss',
    'footer.privacy-center': 'Integritetspolicy',
    
    'search.no-results': 'Din sökning matchade inga resultat',
    'search.results': 'Sökresultat',
    'search.opening-hours-not-available': 'Öppettider inte tillgängliga',
    'search.view-store': 'Visa butik',
    'search.call-store': 'Ring oss',
    'search.floor-1': '1:a våningen',
    'search.floor-2': '2:a våningen',
    'search.floor-3': '3:e våningen',
    'search.floor-4': '4:e våningen',
    'search.floor-5': '5:e våningen',
    'search.store-section-header': 'Butiker',
    'search.offer-section-header': 'Erbjudanden',
    'search.event-section-header': 'Evenemang',
    'search.results-for': 'Resultat för',
    'search.no-results-suggestion': 'Försök med olika nyckelord eller kontrollera stavningen',
    'search.searching': 'Söker...',

    'stores.all-categories': 'Alla kategorier',
    'stores.no-results': 'Inga butiker hittades',
    'stores.all': 'Alla',
    'stores.search-placeholder': 'Sök butiker...',
    'stores.all-floors': 'Alla våningar',
    'stores.floor-1': '1:a våningen',
    'stores.floor-2': '2:a våningen',
    'stores.floor-3': '3:e våningen',
    'stores.floor-4': '4:e våningen',
    'stores.floor-5': '5:e våningen',
    'stores.select-category': 'Välj kategori',
    'stores.opening-hours': 'Öppettider',
    'stores.phone': 'Telefon',
    'stores.email': 'E-post',
    'stores.website': 'Webbplats',
    'stores.address': 'Adress',
    'stores.location': 'Plats',
    'stores.floor': 'Våning',
    'stores.category': 'Kategori',
    'stores.today': 'Idag',
    'stores.tomorrow': 'Imorgon',
    'store.see-on-map': 'Se på kartan',
    'store.exceptions': 'Undantag',
    'store.all-offers': 'Se alla',
    'store.related': 'Relaterade butiker',
    'store.all-related': 'Se alla relaterade butiker',
    'store.status.CLOSED': 'Stängt',
    'store.status.TEMPORARY_CLOSED': 'Tillfälligt stängt',
    'store.status.OPEN': 'Öppet',
    'store.status.BY_APPOINTMENT': 'Efter överenskommelse',
    'store-listing-item-gift-card-support.label': 'Vi tar emot centrumets presentkort',

    'offers.all-categories': 'Alla kategorier',
    'offers.lowest-price-30-days': '30 dagars lägsta pris',
    'offers.search-placeholder': 'Sök erbjudanden, beskrivningar, butiker...',
    'offers.no-results': 'Inga erbjudanden hittades',
    'offers.loading': 'Laddar...',
    
    'lunch-list.modal-title': 'Lunchlista',
    'about-us.opening-hours-note': 'För specifika öppettider på dina favoritköp- och restaurangdestinationer:',
    'about-us.opening-hours-goto-stores': 'Gå till butiker',
    'about-us.opening-hours-center-doors-open': 'Centrets dörrar öppna',
    'about-us.parking-title': 'Parkering',
    'about-us.sustainability-title': 'Hållbarhet',
    'about-us.contact-us-title': 'Kontakta oss',
    'about-us.opening-hours-exceptional': 'Särskilda öppettider',
    'about-us.navigation-tabs-placeholder': 'Välj ämne',

    // For campaign pages:
    'offers.allDays': 'Alla dagar',
    'offers.allCategories': 'Alla kategorier',
    'offers.allOffers': 'Alla erbjudanden',
    'offers.showWishList': 'Visa önskelista',
    'offers.closeOffer': 'Stäng',
    'offers.seeWholeOffer': 'Se hela erbjudandet',
    'offers.noOffers': 'Tyvärr finns inga erbjudanden tillgängliga för tillfället',
    'offers.openInfo':'Öppna erbjudandebeskrivning',
    'offers.daysLowestPrice': '30 dagars lägsta pris',
    'offers.send-email': 'Skicka e-post',
    'offers.valid': 'Gäller',
    'offers.noSearchResults': 'Inga resultat hittades för din sökning',
    'offers.noContent':'Inget innehåll tillgängligt för tillfället',
    'offers.searchBox':'Söka',
    'offers.clearSelection': 'Rensa val',
    'offers.store': 'Butiker',
    'offers.offer': 'Erbjudanden',
    'offers.selectedDays': '{count} dagar valda',
    'offers.selectedCategories': '{count} kategorier valda',
    'search.noResults': 'Inga resultat',
    'search.placeholder': 'Sök',
    'campaign.all-program': 'Visa alla program',
    'campaign.all-days': 'Alla dagar',
    'campaign.all-categories': 'Alla kategorier',

    'news-and-events.news-and-events': 'Nyheter och evenemang',
    
    'offer-lists.search-filter-store-name': 'Butik',
    'offer-lists.valid-from': 'Gäller från',

    'news-and-events-lists.search-filter-keyword': 'Nyckelord',

    'news-and-events-single-article.read.more': 'Läs mer nyheter och evenemang',

    'news-letter-lift.email-address': 'Ange din e-postadress här',
    'news-letter-lift.subscribe': 'Prenumerera',
    'news-letter-lift.confirmation-message': 'Du har framgångsrikt prenumererat på nyhetsbrevet!',

    'feedback.required_fields_marked_by_star': 'Obligatoriska fält',
    'feedback.target': 'Mål',
    'feedback.choose_shop' : 'Välj en butik',
    'feedback.type_of_feedback' : 'Typ av feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Namn',
    'feedback.email' : 'E-post',
    'feedback.target.general': 'Allmän feedback',
    'feedback.target.store': 'Feedback till specifikt företag',
    'feedback.type.thanks': 'Tack',
    'feedback.type.suggestion': 'Förslag',
    'feedback.type.complaint': 'Klagan',
    'feedback.type.other': 'Övrigt',
    'feedback.rsvp' : 'Jag vill få svar',
    'feedback.privacy_statement' : 'Integritetspolicy',
    'feedback.thank_you' : 'Tack för din feedback',
    'feedback.send': 'Skicka',
    'feedback.error.check_all_required_fields': 'Kontrollera att alla obligatoriska fält är ifyllda',
    'feedback.error.field_required' : 'Fältet är obligatoriskt',
    'feedback.error.invalid_email_address' : 'Ogiltig e-postadress',
    'feedback.error.please_choose_a_store' : 'Välj en butik',
  }
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
